// extracted by mini-css-extract-plugin
export var GoToHistoryCard = "postGrid-module--GoToHistoryCard--bc59e";
export var GoToHistoryCard_arrow = "postGrid-module--GoToHistoryCard_arrow--a5104";
export var GoToHistoryCard_title = "postGrid-module--GoToHistoryCard_title--6b35e";
export var NoResultsMessage = "postGrid-module--NoResultsMessage--c76fb";
export var PostCard = "postGrid-module--PostCard--0b89e";
export var PostCard___colored = "postGrid-module--PostCard___colored--18919";
export var PostCard___img = "postGrid-module--PostCard___img--09245";
export var PostCard_date = "postGrid-module--PostCard_date--5c7e9";
export var PostCard_date___alignStart = "postGrid-module--PostCard_date___alignStart--2d872";
export var PostCard_description = "postGrid-module--PostCard_description--83971";
export var PostCard_playSymbol = "postGrid-module--PostCard_playSymbol--5fa7d";
export var PostCard_tag = "postGrid-module--PostCard_tag--a99da";
export var PostCard_title = "postGrid-module--PostCard_title--1875b";
export var PostCard_type = "postGrid-module--PostCard_type--1903c";
export var PostGrid = "postGrid-module--PostGrid--2fc1e";
export var PostGrid_title = "postGrid-module--PostGrid_title--5b903";
export var Postcard_content = "postGrid-module--Postcard_content--abf92";
export var Postcard_img = "postGrid-module--Postcard_img--08cd1";
export var slideIn = "postGrid-module--slide-in--a19d1";
export var slideInFromRight = "postGrid-module--slide-in-from-right--2fe45";